// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-list[data-v-4a3fa6b9] {\n  max-height: 80vh;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.user-label[data-v-4a3fa6b9] {\n  max-width: calc(100% - 16px);\n  margin: auto 8px;\n  font-size: 13px;\n  font-weight: bold;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
